import * as angular from 'angular';

import { Log, ComponentDefinition } from '../../../models';
import { WidgetBase, IWidgetConfiguration } from '../../../widgets';
import { Helper } from '../../../common/helpers';

class LogDetailsController implements angular.IComponentController {
    readonly selectedLog: Log;

    static $inject = [];

    getClass(): any {
        const result: any = {};
        if (this.selectedLog && this.selectedLog.level) {
            switch (this.selectedLog.level) {
                case 'DEBUG':
                    result['text-info'] = true;
                    break;
                case 'INFO':
                    result['text-success'] = true;
                    break;
                case 'WARNING':
                    result['text-warning'] = true;
                    break;
                case 'ERROR':
                    result['text-danger'] = true;
                    break;
                default:
                    break;
            }
        }
        return result;
    }
}

export const wtLogDetails: ComponentDefinition = {
    componentId: 'wtLogDetails',
    controller: LogDetailsController,
    template: require('./logDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedLog: '<'
    }
};

export class LogDetailsWidget extends WidgetBase {
    baseType = 'logDetails';
    col = 0;
    guid: string;
    highlights = ['A component showing the details of a log'];
    icon = 'fa-table';
    name = 'Log Details';
    row = 0;
    sizeX = 6;
    sizeY = 6;
    type = 'logDetails';

    constructor(config?: IWidgetConfiguration) {
        super();
        this.setConfiguration(config);
        this.guid = Helper.getGuid();
    }
}